import React from "react";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";

const MetadataTab = ({
  extractedMetadata,
  setExtractedMetadata,
  isEditingMetadata,
  setIsEditingMetadata,
  isGeneratingMetadata,
  metadataPairs = [],
}) => {
  const lilacBg = "#faf5ff";

  return (
    <Box
      sx={{
        p: 1.5,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        height: "100%",
        overflow: "auto",
        backgroundColor: lilacBg,
      }}
    >
      {/* Extracted Metadata Section */}
      <Box
        sx={{
          backgroundColor: extractedMetadata ? "#f5f3ff" : "#ffffff",
          borderRadius: "6px",
          border: "1px solid #e2e8f0",
          overflow: "hidden",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 1.5,
            py: 0.75,
            borderBottom: "1px solid #e2e8f0",
            backgroundColor: extractedMetadata ? "#f5f3ff" : "#f8fafc",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.75,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: "#374151",
                fontWeight: 600,
                fontSize: "11px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Extracted Text (Complete)
            </Typography>
            {extractedMetadata && (
              <Box
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  backgroundColor: "#8b5cf6",
                }}
              />
            )}
            <Typography
              variant="caption"
              sx={{ color: "#64748b", fontSize: "11px", ml: 1 }}
            >
              (
              {extractedMetadata
                ? "Complete text extracted"
                : "Extract all text with AI"}
              )
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={() => setIsEditingMetadata((v) => !v)}
            sx={{
              width: 22,
              height: 22,
              backgroundColor: isEditingMetadata ? "#8b5cf6" : "transparent",
              color: isEditingMetadata ? "#ffffff" : "#94a3b8",
              "&:hover": {
                backgroundColor: isEditingMetadata ? "#7c3aed" : "#e2e8f0",
              },
            }}
          >
            <EditIcon sx={{ fontSize: 12 }} />
          </IconButton>
        </Box>
        <TextField
          value={extractedMetadata}
          onChange={(e) => setExtractedMetadata(e.target.value)}
          placeholder={
            isGeneratingMetadata
              ? "Extracting all text..."
              : "Click AI button to extract complete text from file"
          }
          multiline
          minRows={10}
          maxRows={15}
          fullWidth
          disabled={!isEditingMetadata}
          sx={{
            flex: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: 0,
              backgroundColor: extractedMetadata
                ? "#e2dfecff"
                : isEditingMetadata
                ? "#e2dfecff"
                : "transparent",
              "& fieldset": { border: "none" },
              overflow: "auto",
            },
            "& .MuiInputBase-input": {
              py: 1,
              px: 1.5,
              fontSize: "13.5px",
              fontFamily: "monospace",
              lineHeight: 1.5,
              color: "#475569",
              overflow: "auto !important",
            },
          }}
        />
      </Box>

      {/* Old metadata pairs section - keeping for backward compatibility but hidden */}
      <Box sx={{ display: "none" }}>
        {metadataPairs.length === 0 ? (
          <Typography variant="body2" sx={{ color: "#94a3b8" }}>
            No metadata
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {metadataPairs.map((pair, idx) => (
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                  opacity: isEditingMetadata ? 1 : 0.9,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: "#64748b", fontWeight: 600 }}
                >
                  {pair?.key || ""}
                </Typography>
                <Typography variant="body2" sx={{ color: "#334155" }}>
                  {pair?.value || ""}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MetadataTab;
